import { Viewer } from '@react-pdf-viewer/core';
import { toolbarPlugin, ToolbarSlot } from '@react-pdf-viewer/toolbar';

import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';

import styles from './CustomPDFViewer.module.scss';

type Props = {
  fileUrl: string;
};

export default function CustomPDFViewer({ fileUrl }: Props) {
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;

  return (
    <div className={styles.pdfGeneral}>
      <div className={styles.toolbar}>
        <Toolbar>
          {(slots: ToolbarSlot) => {
            const {
              CurrentPageInput,
              Download,
              EnterFullScreen,
              GoToNextPage,
              GoToPreviousPage,
              NumberOfPages,
              ShowSearchPopover,
              Zoom,
              ZoomIn,
              ZoomOut,
            } = slots;
            return (
              <div className={styles.toolbarOptionsGeneral}>
                <div className={styles.toolbarOption}>
                  <ShowSearchPopover />
                </div>
                <div className={styles.toolbarOption}>
                  <ZoomOut />
                </div>
                <div className={styles.toolbarOption}>
                  <Zoom />
                </div>
                <div className={styles.toolbarOption}>
                  <ZoomIn />
                </div>
                <div className={styles.toolbarOption2}>
                  <GoToPreviousPage />
                </div>
                <div className={styles.currentPageInput}>
                  <CurrentPageInput />
                </div>
                <div className={styles.toolbarOption}>
                  / <NumberOfPages />
                </div>
                <div className={styles.toolbarOption}>
                  <GoToNextPage />
                </div>
                <div className={styles.toolbarOption2}>
                  <EnterFullScreen />
                </div>
                <div className={styles.toolbarOption}>
                  <Download />
                </div>
              </div>
            );
          }}
        </Toolbar>
      </div>
      <div className={styles.viewer}>
        <Viewer fileUrl={fileUrl} plugins={[toolbarPluginInstance]} />
      </div>
    </div>
  );
}
